// hooks/useCompanyConfig.js
import { useEffect, useState } from "react";
import { getConfig } from "../services/Services";
import { generateErrorMessage } from "../utils/GenerateMessage";

export const useCompanyConfig = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  const getCompanyConfig = async () => {
    // System-admin sessions aren't scoped to a company (no companyId on
    // their token), so this endpoint always 401s ("Invalid authentication!")
    // for them -- and the nav they get (getNavigationAsPerRole "system"
    // branch) never reads `config` anyway. Skip the call for that session
    // type instead of surfacing a spurious error toast on every page load.
    if (localStorage.getItem("admin") === "system") {
      setLoading(false);
      return;
    }
    try {
      const res = await getConfig();
      if (res?.status === 200) {
        setConfig(res?.data?.data?.companyModuels || {});
      } else {
        generateErrorMessage("Something went wrong.");
      }
    } catch (error) {
      generateErrorMessage(
        error?.response?.data?.message || "Something Went Wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanyConfig();
  }, []);

  return { config, loading };
};
